import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Reveal, SectionTitle } from "./Reveal";
import { faqs } from "../data/faqs";

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);


  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 md:py-32 bg-[#09090b] border-t border-amber-500/10" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle eyebrow="Questions fréquentes" title="Vos questions," gold="mes réponses"
          subtitle="Tout ce que vous devez savoir avant de consulter Maître Diamma à La Réunion." />
        <div className="space-y-4" data-testid="faq-accordion">
          {faqs.map((faq, index) => {
            const open = openIndex === index;
            return (
              <Reveal key={faq.question} delay={index * 50}>
                <div className={`rounded-xl border transition-colors duration-300 ${open ? "border-amber-500/40 bg-zinc-900/70" : "border-zinc-800 bg-zinc-950/60"}`}>
                  <button onClick={() => toggleFAQ(index)} data-testid={`faq-question-${index}`}
                    className="w-full px-6 py-5 text-left flex justify-between items-center gap-4">
                    <span className="text-zinc-100 font-medium">{faq.question}</span>
                    <ChevronDown className={`w-5 h-5 text-amber-400 flex-shrink-0 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
                  </button>
                  {open && (
                    <div className="px-6 pb-6 fade-up">
                      <p className="text-zinc-400 leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
